<div class="storage-requests core-screen">
  @if (!embeddedInCabinetPage()) {
  <h1 class="core-title">{{ 'admin.storageRequests.title' | translate }}</h1>
  }

  @if (accessDenied()) {
  <p class="hint error">{{ 'admin.storageRequests.accessDenied' | translate }}</p>
  } @else {
  <div class="search-section">
    <lib-not-input
      type="text"
      [placeholder]="'admin.storageRequests.searchPlaceholder' | translate"
      [ariaLabel]="'admin.storageRequests.searchAriaLabel' | translate"
      [ngModel]="searchQuery()"
      (ngModelChange)="onSearchChange($event)"
      [hideErrorBlock]="true"
    />
  </div>
  <div class="filters-wrap">
    <div class="filters-section filters-section--scroll">
      <div class="filters filters--scroll" role="tablist">
        @for (f of kindFilters; track f.id) {
        <button
          type="button"
          class="chip"
          [class.active]="kindFilter() === f.id"
          (click)="setKindFilter(f.id)"
          role="tab"
          [attr.aria-selected]="kindFilter() === f.id"
        >
          {{ f.labelKey | translate }}
        </button>
        }
      </div>
    </div>
    <div class="filters-section filters-section--scroll">
      <div class="filters filters--scroll" role="tablist">
        @for (f of statusFilters; track f.id) {
        <button
          type="button"
          class="chip"
          [class.active]="orderStatusFilter() === f.id"
          (click)="setOrderStatusFilter(f.id)"
          role="tab"
          [attr.aria-selected]="orderStatusFilter() === f.id"
        >
          {{ f.labelKey | translate }}
        </button>
        }
      </div>
    </div>
  </div>

  <div class="list">
    @if (error()) {
    <p class="hint error">{{ error() }}</p>
    } @else if (loading()) {
    <p class="hint" role="status">{{ 'admin.staffQrScan.loading' | translate }}</p>
    } @else if (items().length === 0) {
    <section class="empty" role="status" aria-live="polite">
      @if (hasFiltersActive()) {
      <h2 class="empty-title">{{ 'admin.storageRequests.emptyFiltered' | translate }}</h2>
      <p class="empty-hint">{{ 'admin.storageRequests.emptyFilteredHint' | translate }}</p>
      } @else {
      <h2 class="empty-title">{{ 'admin.storageRequests.empty' | translate }}</h2>
      <p class="empty-hint">{{ 'admin.storageRequests.emptyHint' | translate }}</p>
      }
    </section>
    } @else {
    @for (row of items(); track row.id) {
    @let contactLine = cardContactLine(row);
    <button type="button" class="card" (click)="onOpen(row.id)">
      <div class="card-top">
        <span class="name">{{ cardPrimaryLine(row) }}</span>
      </div>
      <div class="badges">
        <span class="badge badge--id">{{ formatOrderShortPublicId(row.id) }}</span>
        <span class="badge" [attr.data-status]="row.status">{{
          statusLabelKey(row.status) | translate
        }}</span>
      </div>
      @if (contactLine) {
      <div class="meta muted contact-line">{{ contactLine }}</div>
      }
      <div class="meta muted">{{ kindLabelKey(row) | translate }}</div>
      @if (agreedScheduleAt(row); as agreedAt) {
      <div class="meta muted preferred-at">
        {{ 'admin.storageRequests.orderScheduledAt' | translate }}:
        {{ agreedAt | date: "d MMMM y, HH:mm" }}
      </div>
      } @else if (showPreferredSchedulePending(row) && preferredScheduleAt(row); as preferredAt) {
      <div class="meta muted preferred-at">
        {{ 'admin.storageRequests.preferredAt' | translate }}:
        {{ preferredAt | date: "d MMMM y, HH:mm" }}
      </div>
      <div class="meta muted preferred-at-hint">
        {{ 'admin.storageRequests.preferredAtPendingHint' | translate }}
      </div>
      }
    </button>
    }
    @if (hasMore()) {
    <lib-not-button
      class="load-more"
      [text]="'admin.storageRequests.loadMore' | translate"
      [color]="'#140342'"
      [bgColor]="'#E8F9F7'"
      [width]="'100%'"
      [size]="'big'"
      [action]="{ type: 'action' }"
      [disabled]="loadingMore()"
      (actionEvent)="loadMore()"
    />
    } }
  </div>
  }
</div>
